import React from "react";
import PerformanceContainer from "../containers/PerformanceContainer";

export default function Performance() {
  return <PerformanceContainer />;
}
